export interface IRelativePathHelper {
    resolveRelativePath(path: string);
    getRelativePath(from: string, to: string): string;
}

/*
 * Theses methods are copied from node.js path model source code
 */
export class RelativePathHelper implements IRelativePathHelper {

    static serviceId = 'relativePathHelper';
    static $inject = [];

    resolveRelativePath(path: string) {
        return this.resolveMultiple([path]);
    }

    private resolveMultiple(paths: string[]) {
        let resolvedPath = '';
        let resolvedAbsolute = false;

        for (let i = paths.length - 1; i >= -1 && !resolvedAbsolute; i--) {
            const path = paths[i];

            // Skip empty and invalid entries
            if (!path) {
                continue;
            } else if (typeof path !== 'string') {
                throw new TypeError('Arguments to path.resolve must be strings');
            }

            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path[0] === '/';
        }

        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)

        // Normalize the path
        resolvedPath = this.normalizeArray(resolvedPath.split('/'), !resolvedAbsolute).join('/');

        return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
    }

    getRelativePath(from: string, to: string): string {
        from = this.resolveRelativePath(from).substr(1);
        to = this.resolveRelativePath(to).substr(1);

        const fromParts = this.trimArray(from.split('/'));
        const toParts = this.trimArray(to.split('/'));

        const length = Math.min(fromParts.length, toParts.length);
        let samePartsLength = length;
        for (let i = 0; i < length; i++) {
            if (fromParts[i] !== toParts[i]) {
                samePartsLength = i;
                break;
            }
        }

        let outputParts = [];
        for (let i = samePartsLength; i < fromParts.length; i++) {
            outputParts.push('..');
        }

        outputParts = outputParts.concat(toParts.slice(samePartsLength));

        return outputParts.join('/');
    }

    // resolves . and .. elements in a path array with directory names there
    // must be no slashes or device names (c:\) in the array
    // (so also no leading and trailing slashes - it does not distinguish
    // relative and absolute paths)
    private normalizeArray(parts, allowAboveRoot) {
        const res: string[] = [];
        for (let i = 0; i < parts.length; i++) {
            const p = parts[i];

            // ignore empty parts
            if (!p || p === '.') {
                continue;
            }

            if (p === '..') {
                if (res.length && res[res.length - 1] !== '..') {
                    res.pop();
                } else if (allowAboveRoot) {
                    res.push('..');
                }
            } else {
                res.push(p);
            }
        }

        return res;
    }

    // returns an array with empty elements removed from either end of the input
    // array or the original array if no elements need to be removed
    private trimArray(arr) {
        const lastIndex = arr.length - 1;
        let start = 0;
        for (; start <= lastIndex; start++) {
            if (arr[start]) {
                break;
            }
        }

        let end = lastIndex;
        for (; end >= 0; end--) {
            if (arr[end]) {
                break;
            }
        }

        if (start === 0 && end === lastIndex) {
            return arr;
        }
        if (start > end) {
            return [];
        }
        return arr.slice(start, end + 1);
    }
}